<template>
  <el-input
    v-if="maxLength != 0"
    v-model="val"
    type="hidden"
    size="small"
    :disabled="disabled"
    :minlength="minLength"
    :maxlength="maxLength"
    show-word-limit
    placeholder="请输入内容"
    :class="{'require':getRequire && isNull()}"
    @input="input"
  />
  <el-input
    v-else
    v-model="val"
    type="hidden"
    size="small"
    :disabled="disabled"
    :minlength="minLength"
    show-word-limit
    placeholder="请输入内容"
    :class="{'require':getRequire && isNull()}"
    @input="input"
  />
</template>

<script>
import { verify } from '@/utils/ik/verify/verify.js'
export default {
  name: 'IkTableHidden',
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'input'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    minLength: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      val: '',
      errorSign: false,
      message: ''
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  watch: {
    value: {
      handler(value, oldValue) {
        if (value !== null && value !== '' && value !== undefined) {
          this.val = value
        } else {
          this.val = this.defaultValue
        }
        this.input(this.val)
      },
      immediate: true
    }
  },
  // 如果value为空，取默认值
  created() {
    this.input(this.value)
  },
  methods: {
    input(value) {
      // 取值验证
      this.message = verify(value, this.rules)
      if (this.message !== null) {
        this.errorSign = true
      } else {
        this.errorSign = false
      }
      // 空值验证
      if (this.isNull() && this.require) {
        this.errorSign = true
        this.message = "必填项，不可为空"
      }
      // v-model实现触发方法
      this.$emit('onFieldChange', this.line, this.code, '', value, this.errorSign, this.message)
      this.$emit('input', value)
    },
    isNull() {
      return this.val === '' || this.val === null || this.val === undefined
    },
    reset() {
      this.value = this.defaultValue
    },
    clean() {
      this.value = ''
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
    border: red 1px solid;
}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
